<template>
	<modal ref="modal">
		<template #title>Add BCC</template>
		<template #body>
			<div class="row">
				<div class="col-12">
					<label class="form-label">Choose Subscription</label>
					<div
						class="form-check form-block mb-3"
						v-for="product in products"
						:key="product.prod_id"
					>
						<input
							v-model="form.product_id"
							class="form-check-input"
							type="radio"
							:value="product.prod_id"
							:id="product.prod_id"
							name="subscription"
						/>
						<label class="form-check-label" :for="product.prod_id">
							<span class="d-flex align-items-center">
								<h6 class="fs-sm mb-0">
									{{ product.membership_type }}
								</h6>
								<span v-if="product.add_display" class="badge bg-warning ms-1">
									{{ product.add_display }}
								</span>
							</span>
							<small>&#8369;{{ product.post_amount }}</small>
						</label>
					</div>
				</div>
				<div v-if="form.errors.prod_id" class="col-12">
					<div class="alert alert-danger">
						<p class="mb-0">Please choose subsctiption</p>
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<button
				@click="addSubscription"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				Add Subscription
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		member: Object,
		products: Object,
		user: Object,
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const form = useForm({
			member_id: props.member.counter,
			member_email: props.member.email,
			product_id: null,
			added_by: props.user.full_name,
		})

		const addSubscription = () => {
			form.post(route('admin.post.add-subscription'), {
				preserveState: true,
				preserveScroll: true,
				onSuccess: () => {
					form.reset()
					toggleModal()
				},
			})
		}

		return {
			form,
			modal,
			toggleModal,
			addSubscription,
		}
	},
}
</script>
